import { defineStore } from 'pinia';

import * as state from './auth.state';
import * as getters from './auth.getters';
import * as actions from './auth.actions';

export const useAuthStore = defineStore('auth', () => ({
  ...state,
  ...getters,
  ...actions
}));
